<div class="notification">
    <mat-icon *ngIf="!notification?.total" title="No notifications" class="disable">notifications_none</mat-icon>
    <button mat-icon-button *ngIf="notification?.total" [matMenuTriggerFor]="menu">
        <mat-icon [matBadge]="notification.total" matBadgeColor="warn" matBadgeSize="small" matBadgePosition="above after" matBadgeOverlap="true">notifications_active</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        <a mat-menu-item *ngIf="notification?.chargeBlastEvents" [routerLink]="['/main/charge-blast-events']">
            <mat-icon>notification_important</mat-icon>
            <span class="text">Change Blast Alerts</span>
            <span class="badge">{{notification.chargeBlastEvents}}</span>
        </a>
        <a mat-menu-item *ngIf="notification?.pendingPaymentRequests" [routerLink]="['/main/pending-payment-requests']">
            <mat-icon>notification_important</mat-icon>
            <span class="text">Pending Payment Requests</span>
            <span class="badge">{{notification.pendingPaymentRequests}}</span>
        </a>
    </mat-menu>
</div>
